var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "800px",
    height: "800px",
    viewBox: "-0.23 0 16 16",
    id: "branch-16px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M-12.5-96h-7A1.5,1.5,0,0,0-21-94.5v3a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-3a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5V-81h-2v-3.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5V-81h-1.5a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5H-11V-94.5A1.5,1.5,0,0,0-12.5-96ZM-17-81v-3h2v3Zm0-10h-2v-2h2Zm4,0h-2v-2h2Zm-2,2h2v2h-2Zm-3.755,2H-17v-2h-2v1.526a4.023,4.023,0,0,0-.646-.88,4.042,4.042,0,0,0-5.708,0,4.042,4.042,0,0,0,0,5.708l2.5,2.5A.5.5,0,0,0-22.5-80a.5.5,0,0,0,.354-.146l2.5-2.5A4.041,4.041,0,0,0-18.755-87ZM-22.5-81.207l-2.146-2.147a3.037,3.037,0,0,1,0-4.292,3.024,3.024,0,0,1,2.146-.888,3.024,3.024,0,0,1,2.146.888,3.037,3.037,0,0,1,0,4.292ZM-21-85.5A1.5,1.5,0,0,1-22.5-84,1.5,1.5,0,0,1-24-85.5,1.5,1.5,0,0,1-22.5-87,1.5,1.5,0,0,1-21-85.5Z",
    transform: "translate(26.534 96)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.ccce14439e4ee84d2dd856294bb840f7.svg";
export { ForwardRef as ReactComponent };